import { getFullBox } from "@/components/occlusal/OcclusalTools.js";

function leaveHideMode() {
  if (vueApp.isHideMode) {
    console.log("leaveHideMode");
    vueApp.isHideMode = false;
    let visibleBox = getFullBox(true);
    let vcenter = visibleBox.center;
    vueApp.lookAtPoint(vcenter);
    $(".hide-mode-item").css("display", "none"); // 3.4
  }
}

export { leaveHideMode };
